module.exports = __webpack_public_path__ + "static/media/my notifications icon (active).c5167bde.svg";